import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ArrowLeft } from 'react-bootstrap-icons';
import SummarySurvey from './summarySurvey';
import Accordion from 'react-bootstrap/Accordion';
import WeedsSummary from './weeds/weedsSummary';
import SurveyNavigation from '../surveyNavigation';
import useGetRequest from '../../../hooks/useGetRequest';
import './summaryPage.css'
import SummaryReport from './report/summaryReport';
import getListOfCrops from '../../../helpers/getListOfCrops';
import getListOfOtherCrops from '../../../helpers/getListOfOtherCrops';
import OtherCropSummary from './otherCrop/otherCropSummary';
import GeneralPracticesSummary from './generalPractices/generalPracticesSummary';
import ResistanceSummary from './resistance/resistanceSummary';
import {
    getPestSummaryHelperFunctionFromCropName,
    getDiseaseSummaryHelperFunctionFromCropName,
    getWeedsSummaryHelperFunctionFromCropName
} from "./SummaryMeasures"
import CropSummary from "./CropSummary";
import { ConvertCropNameToTitle } from '../../../helpers/Helpers';
import CropAreaSummaryTable from './CropAreaSummaryTable';

const SummaryPage = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.state === null || location.state.farmData === null) {
            navigate("/farm-list");
        };
        handleDataFetch();
    }, []);
    const { get } = useGetRequest(`/api/user`);
    const [userData, setUserData] = useState([]);

    const handleDataFetch = async () => {
        const data = await get();
        if (data !== undefined) {
            setUserData(data);
        }
    }
    let crops = location.state.crops;
    let listOfCrops = getListOfCrops(location.state?.surveyData.landParcels);
    const listOfOtherCrops = getListOfOtherCrops(location.state?.surveyData.landParcels);
    const cropWithTitle = location.state?.surveyData.landParcels[0].crops.map((crop) => {
        if (crop.isOther)
            return { crop, cropTitle: crop.cropType, area: crop.area}
        return (
            { crop, cropTitle: ConvertCropNameToTitle(crop.cropType), area:crop.area}
    )});
    return (
        <>
            <div className="row my-3">
                <h1 className="text-uppercase font-weight-bold">
                    {location.state.farmData.name} - <u>summary page</u> - {location.state.surveyData.year}
                </h1>
                <h2>You have finished your IPM Plan</h2>
                <div className='mt-2'>
                    To claim BASIS points please send an email to <a href="mailto:cpd@basis-reg.co.uk">cpd@basis-reg.co.uk</a> quoting the following references as appropriate:
                    <ul>
                        <li>BASIS <strong>Professional</strong> Register - <strong>IPM/131385/2324/k</strong></li>
                        <li>BASIS <strong>Environmental Advisers</strong> Register - <strong>IPM/131386/2324/I</strong></li>
                    </ul>
                </div >
                {userData.basisNumber ?
                    <p className='mt-2 alert alert-info' role="alert">
                        This plan was completed by: <strong>{userData.email}</strong> BASIS registration number: <strong>{userData.basisNumber}</strong>
                    </p>
                    :
                    <p className='mt-2 alert alert-warning' role="alert">
                        This plan was completed by: <strong>{userData.email}</strong> BASIS registration number: <strong>______________</strong>
                    </p>
                }
                <p>Please click on each section to get a summary table of the data entered.</p>

                {/* Summary PDF report for this section is based on this HTML structure. Do not change without adjusting PDF generation logic */}
                <Accordion className="cropping-summary-accordion">
                    <Accordion.Item eventKey="17">
                        <Accordion.Header><h3>Cropping Summary</h3>
                            <h6 className='accordionHeader'>Click here to open/close</h6>
                        </Accordion.Header>
                        <Accordion.Body>
                            <CropAreaSummaryTable data={cropWithTitle} />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                

                <Accordion className="general-practices-accordion">
                    
                    <Accordion.Item key="0" eventKey="0">
                        <Accordion.Header><h3>General Practices</h3>
                            <h6 className='accordionHeader'>Click here to open/close</h6>
                        </Accordion.Header>
                        <Accordion.Body>
                            <GeneralPracticesSummary surveyData={location.state.surveyData} />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                {
                    listOfCrops.length === 0 &&
                    <h3>No crops selected</h3>
                }
                <Accordion alwaysOpen flush>
                    {
                        listOfCrops.map((cropName, cropIndex) => (
                            <>
                                <Accordion.Item key={cropIndex} eventKey={cropIndex}>
                                    <Accordion.Header><h3>{ConvertCropNameToTitle(cropName)}</h3>
                                        <h6 className='accordionHeader'>Click here to open/close</h6>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <CropSummary
                                            cropPestSummaryMeasures={getPestSummaryHelperFunctionFromCropName(cropName)}
                                            cropDiseaseSummaryMeasures={getDiseaseSummaryHelperFunctionFromCropName(cropName)}
                                            cropWeedsSummaryMeasures={getWeedsSummaryHelperFunctionFromCropName(cropName)}
                                            surveyData={location.state.surveyData}
                                            cropName={cropName}
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </>
                        ))
                    }
                    {
                        listOfOtherCrops.map((otherCrop, index) => {
                            return (
                                <>
                                    <Accordion.Item eventKey={18 + index} >
                                        <Accordion.Header><h3>{otherCrop}</h3>
                                            <h6 className='accordionHeader'>Click here to open/close</h6></Accordion.Header>
                                        <Accordion.Body>
                                            <OtherCropSummary surveyData={location.state.surveyData} cropName={otherCrop} key={otherCrop} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </>
                            )
                        }
                        )
                    }
                    <Accordion.Item eventKey="16">
                        <Accordion.Header><h3>Weeds</h3>
                            <h6 className='accordionHeader'>Click here to open/close</h6></Accordion.Header>
                        <Accordion.Body>
                            <WeedsSummary surveyData={location.state.surveyData} cropName={'winterWheat'} />
                        </Accordion.Body>
                    </Accordion.Item>

                        
                    
                </Accordion>
                {/* Summary PDF report for this section is based on this HTML structure. Do not change without adjusting PDF generation logic */}
                <Accordion className="resistance-management-accordion">
                    <Accordion.Item key="0" eventKey="0">
                        <Accordion.Header><h3>Resistance Management</h3>
                            <h6 className='accordionHeader'>Click here to open/close</h6>
                        </Accordion.Header>
                        <Accordion.Body>
                            <ResistanceSummary surveyData={location.state.surveyData} />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                
                <SummaryReport
                    listOfOtherCrops={listOfOtherCrops}
                    listOfCrops={listOfCrops}
                    userEmail={userData.email}
                    basisNumber={userData.basisNumber}
                    farmData={location.state.farmData}
                    surveyData={location.state.surveyData} />
                <SummarySurvey />
            </div >
            <div className="row justify-content-between my-5">
                <Link className="col-2 mx-3"
                    to={`/add-diseases-resistance`}
                    state={{
                        farmData: location.state.farmData,
                        surveyData: location.state.surveyData,
                        crops: crops
                    }}>
                    <button type="button" className="btn btn-warning w-100 h-100"><ArrowLeft size={20} className="mx-2"></ArrowLeft>Go back</button>
                </Link>
                <SurveyNavigation farmData={location.state.farmData} surveyData={location.state.surveyData} crops={location.state.crops} />
                <Link className="col-2 mx-3" to="/farm-list">
                    <button type="button" className="btn btn-success">Go back to your farms</button>
                </Link>
            </div>
        </>
    );
};

export default SummaryPage;